import React from "react";
import { Inner } from "./styles.js";
import QuotationPersonalData from "./components/form_quotation_personal_data/QuotationPersonalData.js";
import QuotationResults from "./components/form_quotation_results/QuotationResults.js";

const Step2Quotation = ({ nextMainStep, step2Car, setStep2Car, isMobile }) => {
	const renderStep2Car = () => {
		switch (step2Car) {
			case 0:
				return (
					<QuotationPersonalData
						nextSubStep={handleSubStepSubmit}
						nextMainStep={nextMainStep}
						isMobile={isMobile}
					/>
				);
			case 1:
				return (
					<QuotationResults
						nextSubStep={handleSubStepSubmit}
						nextMainStep={nextMainStep}
						isMobile={isMobile}
					/>
				);
			default:
				return null;
		}
	};

	const handleSubStepSubmit = (step) => {
		setStep2Car(step);
	};

	return <Inner>{renderStep2Car()}</Inner>;
};

export default Step2Quotation;
